module.exports = __webpack_public_path__ + "static/banner-image-32b681061bd89fe2a162622dea50d6d9.jpg";